import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

const CREATE_EVENT_TICKET = gql`
  mutation CreateEventTicket($input: CreateEventTicketInput!) {
    createEventTicket(input: $input) {
      id
      event_id
      name
      price
      track_price
      type
      start_date
      end_date
      color_code
      limit
      description
      fee_dollar
      fee_percent
      sale_start
      sale_end
      on_sale_time
      off_sale_time
      associated_tickets {
        id
        name
        quantity
      }
    }
  }
`;

export function useCreateEventTicket() {
  const [createEventTicketMutation, { loading, error }] =
    useMutation(CREATE_EVENT_TICKET);

  const createEventTicket = useCallback(
    async (input) => {
      const response = await createEventTicketMutation({
        variables: { input },
      });
      return response;
    },
    [createEventTicketMutation]
  );

  return { createEventTicket, loading, error };
}
